import React, { useRef, useEffect } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Checkbox,
  Button,
  Chip,
  Toolbar,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Person as PersonIcon,
  Description as DescriptionIcon,
  CalendarToday as CalendarTodayIcon,
  History as HistoryIcon,
  Send as SendIcon,
  FilterList as FilterListIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import moment from 'moment';

export default function TFacturas({ rows, termf, seleccionarFacturas }) {
  const mounted = useRef(true);
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const history = useHistory();

  const irAHistorialDeTareas = (factura) => {
    factura['TipoVisitante'] = 'Visitante';
    history.push({ pathname: '/historialTareasFactura', state: factura });
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(rows || []);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, row) => {
    const selectedIndex = selected.indexOf(row);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  function searchingTermf(termf) {
    const lower = termf ? termf.toLowerCase() : '';

    return (x) => {
      const campos = [
        x.usuario?.nombrecompleto,
        x.cliente?.nombre,
        x.cliente?.apellido,
        x.timbrado,
        x.nrocomprobante,
        x.fechacomprobante,
        x.fechavencimiento,
        x.totalfactura,
        x.montopagado,
      ]
        .filter(Boolean)
        .map((c) => c.toString().toLowerCase());

      return campos.some((campo) => campo.includes(lower)) || !termf;
    };
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (row) => selected.indexOf(row) !== -1;

  const filteredRows = (rows || []).filter(searchingTermf(termf));
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    return function cleanup() {
      mounted.current = false;
    };
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      {/* Toolbar de selección */}
      <Toolbar
        sx={{
          pl: 2,
          pr: 1,
          ...(selected.length > 0 && {
            bgcolor: '#e3f2fd',
          }),
        }}
      >
        {selected.length > 0 ? (
          <Typography
            sx={{ flex: '1 1 100%' }}
            color="primary"
            variant="subtitle1"
            component="div"
          >
            {selected.length} Seleccionado/s
          </Typography>
        ) : (
          <Typography
            sx={{ flex: '1 1 100%' }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            Seleccionar Facturas para comenzar seguimiento
          </Typography>
        )}

        {selected.length > 0 ? (
          <Tooltip title="Crear Tarea">
            <IconButton onClick={() => seleccionarFacturas(selected)}>
              <SendIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Lista de Facturas">
            <IconButton aria-label="filter list">
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </Toolbar>

      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                padding="checkbox"
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                <Checkbox
                  indeterminate={
                    selected.length > 0 && selected.length < (rows?.length || 0)
                  }
                  checked={(rows?.length || 0) > 0 && selected.length === rows.length}
                  onChange={handleSelectAllClick}
                  inputProps={{ 'aria-label': 'seleccionar todas' }}
                />
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Usuario
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Cliente
              </TableCell>
              {/* <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Timbrado
              </TableCell> */}
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Fac.Nro
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Fecha Fac
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Fecha Vto
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Total Factura
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Abonado
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Saldo a pagar
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: '#e3f2fd',
                  fontWeight: 700,
                  borderBottom: 2,
                  borderColor: 'primary.main',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                }}
              >
                Acciones
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((row, index) => {
                const isItemSelected = isSelected(row);
                const saldo = row.totalfactura - row.montopagado;
                const isVencido =
                  moment(row.fechavencimiento).format() < moment().format();

                return (
                  <TableRow
                    hover
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    key={row.id || index}
                    selected={isItemSelected}
                    sx={{
                      backgroundColor: !row.tieneTareas
                        ? '#ffd7d7ff'
                        : row.tienePendientes
                        ? '#fff3cd'
                        : 'inherit',
                      '&:hover': {
                        backgroundColor: !row.tieneTareas
                          ? '#ffcccc'
                          : row.tienePendientes
                          ? '#ffe8a3'
                          : '#f5f5f5',
                      },
                      '&:nth-of-type(even)': {
                        backgroundColor: (theme) =>
                          !row.tieneTareas
                            ? '#ffd7d7ff'
                            : row.tienePendientes
                            ? '#fff3cd'
                            : theme.palette.action.hover,
                      },
                    }}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        onClick={(event) => handleClick(event, row)}
                        checked={isItemSelected}
                        inputProps={{
                          'aria-labelledby': `enhanced-table-checkbox-${index}`,
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PersonIcon sx={{ fontSize: 20, color: 'action.active' }} />
                        <Typography variant="body2">
                          {typeof row.usuario === 'string'
                            ? row.usuario
                            : row.usuario?.nombrecompleto || row.Usuario || '—'}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {typeof row.cliente === 'string'
                          ? row.cliente
                          : `${row.cliente?.nombre ?? ''} ${
                              row.cliente?.apellido ?? ''
                            }`.trim() || '—'}
                      </Typography>
                    </TableCell>
                    {/* <TableCell>
                      <Chip
                        icon={<ReceiptIcon />}
                        label={row.timbrado}
                        size="small"
                        variant="outlined"
                        color="default"
                      />
                    </TableCell> */}
                    <TableCell>
                      <Chip
                        icon={<DescriptionIcon />}
                        label={row.nrocomprobante}
                        size="small"
                        variant="outlined"
                        color="primary"
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CalendarTodayIcon
                          sx={{ fontSize: 18, color: 'action.active' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{ fontFamily: 'monospace' }}
                        >
                          {moment(row.fechacomprobante).format('DD/MM/YYYY')}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <CalendarTodayIcon
                          sx={{ fontSize: 18, color: 'action.active' }}
                        />
                        <Typography
                          variant="body2"
                          sx={{
                            fontFamily: 'monospace',
                            color: isVencido ? 'error.main' : 'success.main',
                            fontWeight: isVencido ? 600 : 400,
                          }}
                        >
                          {moment(row.fechavencimiento).format('DD/MM/YYYY')}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: 'success.main' }}
                      >
                        {Intl.NumberFormat('es').format(row.totalfactura)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {Intl.NumberFormat('es').format(row.montopagado)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 600,
                          color: saldo > 0 ? 'error.main' : 'success.main',
                        }}
                      >
                        {Intl.NumberFormat('es').format(saldo)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<HistoryIcon />}
                        onClick={() => irAHistorialDeTareas(row)}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          px: 1.5,
                          borderRadius: 1.5,
                          boxShadow: 1,
                          '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-1px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        Historial
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center" sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2,
                      color: 'text.secondary',
                    }}
                  >
                    <ReceiptIcon sx={{ fontSize: 64, opacity: 0.3 }} />
                    <Typography variant="h6">
                      No se encontraron facturas
                    </Typography>
                    <Typography variant="body2">
                      {termf
                        ? 'Intenta con otros términos de búsqueda'
                        : 'Aún no hay facturas registradas'}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontWeight: 500,
          },
        }}
      />
    </Box>
  );
}
